// extracted by mini-css-extract-plugin
export default {"progressCircle":"ProgressCircle_progressCircle__7fkZL","shadowedCircle":"ProgressCircle_shadowedCircle__EvQgN"};